import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/close-circle-2.svg'


const _hoisted_1 = {
  class: "modal fade",
  id: "detailsModal",
  tabindex: "-1",
  "aria-labelledby": "detailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-rl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title text-title",
  id: "detailsModalLabel"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["alt"]
const _hoisted_8 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_9 = { class: "details-title list-style mb-40" }
const _hoisted_10 = { class: "fs-14 fw-medium text-title lh-1" }
const _hoisted_11 = { class: "fw-semibold ms-1" }
const _hoisted_12 = { class: "fs-14 fw-medium text-title lh-1" }
const _hoisted_13 = { class: "fw-semibold ms-1" }
const _hoisted_14 = { class: "table-responsive style-two mb-25" }
const _hoisted_15 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_16 = {
  scope: "col",
  class: "text-title fw-normal fs-14 lh-1"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-title fw-normal fs-14 lh-1"
}
const _hoisted_18 = {
  scope: "col",
  class: "text-title fw-normal fs-14 lh-1"
}
const _hoisted_19 = {
  scope: "col",
  class: "text-title fw-normal fs-14 lh-1"
}
const _hoisted_20 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_21 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_22 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_23 = { class: "form-group mb-25" }
const _hoisted_24 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_25 = { class: "fs-14 text-paragraph lh-base" }
const _hoisted_26 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_27 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.t("expense_page.expense_details")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close p-0",
            "data-bs-dismiss": "modal",
            "aria-label": _ctx.t('common.close')
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: _ctx.t('common.close')
            }, null, 8, _hoisted_7)
          ], 8, _hoisted_6)
        ]),
        (_ctx.expense)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.t("expense_page.date")) + " :", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDateTime(_ctx.expense.date)), 1)
                ]),
                _createElementVNode("li", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.t("expense_page.reference")) + " :", 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.expense.referenceno || _ctx.t("expense_page.not_available")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.t("expense_page.no_short")), 1),
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.t("expense_page.category")), 1),
                      _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.t("expense_page.warehouse")), 1),
                      _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.t("expense_page.amount")), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[0] || (_cache[0] = _createElementVNode("td", { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }, "01", -1)),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.expense.category?.name || _ctx.expense.category_name || _ctx.t("expense_page.not_available")), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.expense.warehouse?.name || _ctx.t("expense_page.not_available")), 1),
                      _createElementVNode("td", _hoisted_22, " $" + _toDisplayString(Number(_ctx.expense.amount).toFixed(2)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("expense_page.description")), 1),
                _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.expense.description || _ctx.t("expense_page.no_description_available")), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.t("expense_page.no_expense_selected")), 1)
            ]))
      ])
    ])
  ]))
}